import { ThemeSettingsValueProps } from 'src/components/settings/types';
import { getCurrentSession } from '..';
import useUIState from './persistUiState';
import { PreferenceUIState } from './types';

export const usePreferencesUIState = (): PreferenceUIState => {
  const session = getCurrentSession();
  return useUIState((state) => ({
    preferenceState: state.preferenceState[session?.userId || ''],
    setPreferenceState: (preferenceState: Partial<ThemeSettingsValueProps>) => {
      state.setPreferenceState(session?.userId || '', preferenceState);
    },
  }));
};
